var _defs, _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 220",
    width: 440,
    height: 220,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e9a52f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ba7d13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#734e0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "potGold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe08a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e9a52f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a5b0f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: 0.5,
    cy: 0.45,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120404"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 432,
    height: 212,
    rx: 26,
    fill: "url(#glow)",
    stroke: "url(#gold)",
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220 66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -30              C 34 -30 46 -6 46 22              C 46 52 26 72 0 72              C -26 72 -46 52 -46 22              C -46 -6 -34 -30 0 -30 Z",
    fill: "url(#potGold)",
    stroke: "#5c3c0a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -40,
    width: 48,
    height: 16,
    rx: 7,
    fill: "url(#potGold)",
    stroke: "#5c3c0a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -40,
    rx: 24,
    ry: 7,
    fill: "#ffe9a8",
    stroke: "#5c3c0a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 6 C -22 -14 -10 -22 -2 -22",
    stroke: "#fff6d8",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 38,
    textAnchor: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 42,
    fontWeight: 700,
    fill: "#5c3c0a"
  }, "&#8377;"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 168,
    textAnchor: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 30,
    fontWeight: 700,
    letterSpacing: 1.5,
    fill: "url(#gold)"
  }, "CHANDNI CHOWK")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 200,
    textAnchor: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: 10,
    fill: "#e9a52f"
  }, "MATKA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brandLogo.8f4294a7ef5eee94bb27f0e233cf0e10.svg";
export { ForwardRef as ReactComponent };